/**
 * Deepgram Spend Hook
 * TanStack Query hook for fetching Deepgram usage/billing data
 */

import { useQuery } from '@tanstack/react-query';
import { getDeepgramSpend } from '../api';

/** Query key factory */
export const deepgramSpendKeys = {
  all: ['deepgram-spend'] as const,
  summary: () => [...deepgramSpendKeys.all, 'summary'] as const,
};

/**
 * Hook to fetch Deepgram spend data
 * Refreshes every 5 minutes
 */
export function useDeepgramSpend() {
  return useQuery({
    queryKey: deepgramSpendKeys.summary(),
    queryFn: getDeepgramSpend,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 5 * 60 * 1000, // Auto-refresh every 5 minutes
  });
}
